//core
import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

//styles
import { useStyles } from "../../styles";
import { ChipCyan, ChipDeepOrange } from "../../../../styles";

import { ObjType } from "../../../../utils";
interface IRevenueShareStepsProps {
  data: ObjType[];
  product: string;
  sufix: string;
}

const RevenueShareSteps: React.FC<IRevenueShareStepsProps> = ({
  data,
  product,
  sufix,
}): JSX.Element => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <>
      {!!data.length && data.map((item: any, i: number) => {
        const attributes = item.data.condition_step_items_attributes[0];
        const desired_value = attributes.desired_value !== null ? attributes.desired_value : '';

        return (
          <Box className={styles.step} key={`step-${product}-${i}`}>
            <ChipCyan
              size="small"
              label={`${item.data.payment_size}% ${t("admin.deals.summary.of")} ${t(`common.components.deal_payment_column.${item.data.payment_column}`)}`}
            />
            <Typography variant="body2">
              {t("admin.deals.summary.for")}
            </Typography>
            {/*<Chip
              size="small"
              sx={{ background: green[100] }}
              label={`${t(`admin.deals.form.revenue_share.tabs.${product}`)}`}
            />*/}
            <ChipDeepOrange
              size="small"
              label={`${t(`admin.deals.form.revenue_share.tabs.${product}`)} ${t(`admin.deals.summary.comparison.${attributes.condition_for_comparison}`)} ${desired_value}`}
            />
            {!!sufix && !!data.length && (
              <Typography variant="body2">
                {sufix}
              </Typography>
            )}
          </Box>
        )
      })}
    </>
  );
};

export default RevenueShareSteps;
